import VueRouter, { RouteConfig } from 'vue-router'

import Vue from 'vue'
import userManager from "@/services/userManager"
import store from "@/plugins/store"

Vue.use(VueRouter)

const routes: RouteConfig[] = [
  {
    path: "/delete_user",
    component: () => import('../views/DeleteUser.vue'),
    meta: {
      allowGuest: true,
    },
  },
  {
    path: "/privacy",
    component: () => import('../views/Privacy.vue'),
    meta: {
      allowGuest: true,
    },
  },
  {
    path: "/terms",
    component: () => import('../views/Terms.vue'),
    meta: {
      allowGuest: true,
    },
  },
  {
    path: '',
    redirect: "/app"
  },
  {
    path: "/privacy_policy",
    component: () => import('../views/PrivacyPolicy.vue'),
  },
  {
    path: "/terms_and_conditions",
    component: () => import('../views/TermsAndConditions.vue'),
  },
  {
    path: "/faq",
    component: () => import('../views/Faq.vue'),
  },
  {
    path: "/docs/:id?",
    component: () => import('../views/Docs.vue'),
    meta: {
      allowGuest: true,
    },
  },
  {
    path: "/ext/vnpay_success",
    component: () => import('../views/ext/VnpaySuccess.vue'),
  },
  {
    path: "/ext/vnpay_error",
    component: () => import('../views/ext/VnpayError.vue'),
  },
  {
    path: "/ext/momo_success",
    component: () => import('../views/ext/MomoSuccess.vue'),
  },
  {
    path: "/ext/momo_error",
    component: () => import('../views/ext/MomoError.vue'),
  },
  {
    path: "/ext/napas_success",
    component: () => import('../views/ext/NapasSuccess.vue'),
  },
  {
    path: "/ext/napas_error",
    component: () => import('../views/ext/NapasError.vue'),
  },
  {
    path: '/login',
    component: () => import('../views/Login.vue'),
    beforeEnter(from, to, next) {
      const userInfo = userManager.getUserInfo()
      if (userInfo) {
        next("/app")
      } else {
        next()
      }
    },
  },
  {
    path: '/signup',
    component: () => import('../views/Signup.vue'),
    beforeEnter(from, to, next) {
      const userInfo = userManager.getUserInfo()
      if (userInfo) {
        next("/app")
      } else {
        next()
      }
    },
  },
  {
    path: '/forgot_password',
    component: () => import('../views/ForgotPassword.vue'),
  },
  {
    path: '/reset_password',
    component: () => import('../views/ResetPassword.vue'),
  },
  {
    path: '/active_user',
    component: () => import('../views/ActiveUser.vue'),
  },
  {
    path: '/app',
    component: () => import('../views/app/Layout.vue'),
    beforeEnter(from, to, next) {
      if (to?.meta?.allowGuest || from?.meta?.allowGuest || to?.path === "/") {
        next()
        return
      }
      console.log({
        from,
        to,
      })
      const userInfo = userManager.getUserInfo()
      if (!userInfo) {
        next("/login")
      } else {
        next()
      }
    },
    children: [
      {
        path: "",
        redirect: "index",
        meta: {
          allowGuest: true,
        },
      },
      {
        path: "index",
        component: () => import('../views/app/Index.vue'),
        meta: {
          allowGuest: true,
        },
      },
      {
        path: "action_logs",
        component: () => import('../views/app/ActionLogs.vue'),
      },
      {
        path: "charger_vendors",
        component: () => import('../views/app/ChargerVendors.vue'),
      },
      {
        path: "cars",
        component: () => import('../views/app/Cars.vue'),
      },
      {
        path: "tags",
        component: () => import('../views/app/Tags.vue'),
      },
      {
        path: "charging_details/:id/:connectorId",
        component: () => import('../views/app/ChargingDetails.vue'),
      },
      {
        path: "charging_details_m/:id/:connectorId",
        component: () => import('../views/app/ChargingDetailsM.vue'),
      },
      {
        path: "charging_sessions",
        component: () => import('../views/app/ChargingSessions.vue'),
      },
      {
        path: "retroactive_charges",
        component: () => import('../views/app/RetroactiveCharges.vue'),
      },
      {
        path: "plugged_charging_sessions",
        component: () => import('../views/app/PluggedChargingSessions.vue'),
      },
      {
        path: "charging_sessions/:id",
        component: () => import('../views/app/ChargingDetailsM.vue'),
      },
      {
        path: "charging_sessions_m",
        component: () => import('../views/app/ChargingSessionsM.vue'),
      },
      {
        path: "error_stations",
        component: () => import('../views/app/ChargingStationsError.vue'),
      },
      {
        path: "issues",
        component: () => import('../views/app/Issues.vue'),
      },
      {
        path: "companion",
        component: () => import('../views/app/Companion.vue'),
      },
      {
        path: "promotional_news",
        component: () => import('../views/app/PromotionalNews.vue'),
      },
      // {
      //   path: "promotion_moneys",
      //   component: () => import('../views/app/PromotionMoneys.vue'),
      // },
      {
        path: "licenses",
        component: () => import('../views/app/Licenses.vue'),
      },
      {
        path: "stations_status",
        component: () => import('../views/app/ChargingStationsStatus.vue'),
      },
      {
        path: "charging_locations",
        component: () => import('../views/app/ChargingLocations.vue'),
        meta: {
          allowGuest: true,
        },
      },
      {
        path: "charging_locations_m",
        component: () => import('../views/app/ChargingLocationsM.vue'),
        meta: {
          allowGuest: true,
        },
      },
      {
        path: "charging_stations",
        component: () => import('../views/app/ChargingStations.vue'),
      },
      {
        path: "charging_stations_m",
        component: () => import('../views/app/ChargingStationsM.vue'),
      },
      {
        path: "charging_stations/:id/:connectorId",
        component: () => import('../views/app/ChargingStationConnectorDetails.vue'),
      },
      {
        path: "charging_stations_m/:id/:connectorId",
        component: () => import('../views/app/ChargingStationConnectorDetailsM.vue'),
        meta: {
          allowGuest: true,
        },
      },
      {
        path: "smart_sockets",
        component: () => import('../views/app/SmartSockets.vue'),
      },
      {
        path: "smart_socket_sessions",
        component: () => import('../views/app/SmartSocketSessions.vue'),
      },
      {
        path: "sessions",
        component: () => import('../views/app/Sessions.vue'),
      },
      {
        path: "ocpp_autocharge_found_vehicles",
        component: () => import('../views/app/OcppAutochargeFoundVehicles.vue'),
      },
      {
        path: "ocpp_logs",
        component: () => import('../views/app/OcppLogs.vue'),
      },
      {
        path: "statistics",
        component: () => import('../views/app/Statistics.vue'),
      },
      {
        path: "profile",
        component: () => import('../views/app/Profile.vue'),
      },
      {
        path: "retailers",
        component: () => import('../views/app/Retailers.vue'),
      },
      {
        path: "cashback",
        component: () => import('../views/app/Cashback.vue'),
      },
      {
        path: "cashback/:id",
        component: () => import('../views/app/CashbackDetail.vue'),
      },
      {
        path: "cashback_roaming_in",
        name: "cashback_roaming_in",
        meta: { ocpiMode: "roaming_in" },
        component: () => import('../views/app/Cashback.vue'),
      },
      {
        path: "cashback_roaming_in/:id",
        name: "cashback_roaming_in_detail",
        meta: { ocpiMode: "roaming_in" },
        component: () => import('../views/app/CashbackDetail.vue'),
      },
      {
        path: "cashback_roaming_out",
        name: "cashback_roaming_out",
        meta: { ocpiMode: "roaming_out" },
        component: () => import('../views/app/Cashback.vue'),
      },
      {
        path: "cashback_roaming_out/:id",
        name: "cashback_roaming_out_detail",
        meta: { ocpiMode: "roaming_out" },
        component: () => import('../views/app/CashbackDetail.vue'),
      },
      {
        path: "cashback_partner",
        name: "cashback_partner",
        component: () => import('../views/app/CashbackGroup.vue'),
      },
      {
        path: "cashback_partner/:id",
        name: "cashback_partner_detail",
        component: () => import('../views/app/CashbackDetailGroup.vue'),
      },
      {
        path: "cashback_partner_detail",
        name: "cashback_partner_detail_auto",
        component: () => import('../views/app/CashbackDetailGroup.vue'),
      },
      {
        path: "cashback_roaming_in_partner",
        name: "cashback_roaming_in_partner",
        meta: { ocpiMode: "roaming_in" },
        component: () => import('../views/app/CashbackGroup.vue'),
      },
      {
        path: "cashback_roaming_in_partner/:id",
        name: "cashback_roaming_in_partner_detail",
        meta: { ocpiMode: "roaming_in" },
        component: () => import('../views/app/CashbackDetailGroup.vue'),
      },
      {
        path: "cashback_roaming_in_partner_detail",
        name: "cashback_roaming_in_partner_detail_auto",
        meta: { ocpiMode: "roaming_in" },
        component: () => import('../views/app/CashbackDetailGroup.vue'),
      },
      {
        path: "cashback_roaming_out_partner",
        name: "cashback_roaming_out_partner",
        meta: { ocpiMode: "roaming_out" },
        component: () => import('../views/app/CashbackGroup.vue'),
      },
      {
        path: "cashback_roaming_out_partner/:id",
        name: "cashback_roaming_out_partner_detail",
        meta: { ocpiMode: "roaming_out" },
        component: () => import('../views/app/CashbackDetailGroup.vue'),
      },
      {
        path: "cashback_roaming_out_partner_detail",
        name: "cashback_roaming_out_partner_detail_auto",
        meta: { ocpiMode: "roaming_out" },
        component: () => import('../views/app/CashbackDetailGroup.vue'),
      },
      {
        path: "charging_memberships",
        component: () => import('../views/app/ChargingMembership.vue'),
      },
      {
        path: "charging_memberships_history",
        component: () => import('../views/app/ChargingMembershipHistory.vue'),
      },
      {
        path: "charging_memberships_usage_history",
        component: () => import('../views/app/ChargingMembershipUsageHistory.vue'),
      },
      {
        path: "charging_memberships_dashboard",
        component: () => import('../views/app/ChargingMembershipDashboard.vue'),
      },
      {
        path: "vouchers",
        component: () => import('../views/app/Voucher.vue'),
      },
      {
        path: "vouchers_history",
        component: () => import('../views/app/VoucherHistory.vue'),
      },
      {
        path: "promotions",
        component: () => import('../views/app/Promotions.vue'),
      },
      {
        path: "promotions/:id/transactions",
        component: () => import('../views/app/PromotionTransactions.vue'),
      },
      {
        path: "retailer/:id",
        component: () => import('../views/app/RetailerDetail.vue'),
      },
       {
        path: "tariffs",
        component: () => import('../views/app/Tariffs.vue'),
        beforeEnter(from, to, next) {
          if (store.state.featureConfig?.multiTierPricing?.enabled) {
            next();
          } else {
            next("/app");
          }
        },
      },
      {
        path: "settings",
        component: () => import('../views/app/Settings.vue'),
        children: [
          {
            path: "",
            redirect: "time_zone"
          },
          {
            path: "payment_methods",
            component: () => import('../views/app/settings/PaymentMethods.vue'),
          },
          {
            path: "payment_transactions",
            component: () => import('../views/app/settings/PaymentTransactions.vue'),
          },
          {
            path: "payment_transactions_m",
            component: () => import('../views/app/settings/PaymentTransactionsM.vue'),
          },
          {
            path: "payment_exchange_ratio",
            component: () => import('../views/app/settings/PaymentExchangeRatio.vue'),
          },
          {
            path: "time_zone",
            component: () => import('../views/app/settings/TimeZone.vue'),
          },
          {
            path: "notify_to_users",
            component: () => import('../views/app/settings/NotifyToUsers.vue'),
          },
          {
            path: "terms_and_conditions",
            component: () => import('../views/app/settings/TermsAndConditions.vue'),
          },
          {
            path: "privacy_policy",
            component: () => import('../views/app/settings/PrivacyPolicy.vue'),
          },
          {
            path: "faq",
            component: () => import('../views/app/settings/Faq.vue'),
          },
          {
            path: "docs",
            component: () => import('../views/app/settings/Docs.vue'),
          },
          {
            path: "doc_detail",
            component: () => import('../views/app/settings/DocDetail.vue'),
          },
          {
            path: "mail",
            component: () => import('../views/app/settings/Mail.vue'),
          },
          {
            path: "zns_integration",
            component: () => import('../views/app/settings/ZnsIntegration.vue'),
          },
          {
            path: "roaming",
            component: () => import('../views/app/settings/roaming/Roaming.vue'),
          },
          {
            path: "feature_config",
            component: () => import('../views/app/settings/FeatureConfig.vue'),
            beforeEnter(from, to, next) {
              if (userManager.checkRole(["systemAdmin"])) {
                next();
              } else {
                next("/app");
              }
            },
          },
          {
            path: "napas_merchants",
            component: () => import('../views/app/settings/NapasMerchants.vue'),
            beforeEnter(from, to, next) {
              if (userManager.checkRole(["systemAdmin", "admin", "cpoAdmin"])) {
                next();
              } else {
                next("/app");
              }
            },
          },
        ],
      },
      {
        path: "tenants",
        component: () => import('../views/app/Tenants.vue'),
      },
      {
        path: "partners",
        component: () => import('../views/app/CpoGroups.vue'),
      },
      {
        path: "api_credentials",
        component: () => import('../views/app/ApiCredentials.vue'),
      },
      {
        path: "users",
        component: () => import('../views/app/Users.vue'),
      },
      {
        path: "app-versions",
        component: () => import('../views/app/AppVersion.vue'),
      },
      {
        path: "my_charger/home_m",
        component: () => import('../views/app/my_charger/HomeM.vue'),
      },
      {
        path: "my_charger/login_charger_m",
        component: () => import('../views/app/my_charger/LoginChargerM.vue'),
      },
      {
        path: "my_charger/scanning_qr_code_m",
        component: () => import('../views/app/my_charger/ScanQrCodeM.vue'),
      },
      {
        path: "my_charger/charging_stations_m/:id/:connectorId",
        component: () => import('../views/app/my_charger/ChargingDetailM.vue'),
        meta: {
          allowGuest: true,
        },
      },
      {
        path: "my_charger/charging_session_history_m/:id/:connectorId",
        component: () => import('../views/app/my_charger/ChargingSessionHistory.vue'),
        meta: {
          allowGuest: true,
        },
      },
      {
        path: "maps",
        component: () => import('../views/app/Maps.vue'),
      },
      {
        path: "my_charger/charging_config_m/:id/:connectorId",
        component: () => import('../views/app/my_charger/ChargingConfig.vue'),
        meta: {
          allowGuest: true,
        },
      },
      {
        path: "site_area",
        component: () => import('../views/app/SiteArea.vue'),
      },
    ]
  },
]

const router = new VueRouter({
  base: "/",
  routes
})

export default router
